import classnames from "classnames";
import { Loading } from "components/assets/Icons";

import styles from "./FormField.module.scss";

export const TYPE = {
  PASSWORD: "password",
  TEXTAREA: "textarea",
  CHECKBOX: "checkbox",
  NUMBER: "number",
};

export const STYLE = {
  THIN: "thin",
  MODAL: "modal",
  LIGHT: "light",
  POPUP: "popup",
  FORM: "form",
  FORM_PHONE: "form_phone",
  FORM_SMALL: "form_s",
  NOTE: "note"
};

export const SIZE = {
  SMALL: "small",
};

const FormField = ({
  type = "text",
  fieldName,
  labelText,
  placeholderText = "",
  value,
  defaultValue,
  required,
  onChange,
  className,
  error,
  icon,
  style,
  size,
  maxWidth,
  maxLength,
  disabled,
  errorMessage,
  loading,
  readOnly,
  register = () => {},
  suffix,
}) => {
  return (
    <div
      className={classnames(
        styles.item,
        className,
        {
          [styles[style]]: style,
        },
        { [styles[size]]: size },
      )}
    >
      {labelText && (
        <label htmlFor={fieldName} className={styles.label}>
          {labelText}
        </label>
      )}
      <span className={styles.wrapper}>
        {icon && <span className={styles.icon}>{icon}</span>}
        {type !== "textarea" && (
          <input
            type={type}
            id={fieldName}
            name={fieldName}
            placeholder={placeholderText}
            className={classnames(styles.input, error && styles.error)}
            required={required}
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
            style={{ maxWidth: maxWidth }}
            disabled={disabled}
            maxLength={maxLength}
            min={type === "number" ? 0 : ""}
            readOnly={readOnly}
            {...register(fieldName)}
          />
        )}
        {suffix && <span className={styles.suffix}>{suffix}</span>}
        {type === "textarea" && (
          <textarea
            id={fieldName}
            value={value}
            name={fieldName}
            placeholder={placeholderText}
            className={classnames(styles.input, error && styles.error)}
            onChange={onChange}
            {...register(fieldName)}
          />
        )}
        {(errorMessage !== "" || error?.message) && (
          <p className={styles.message}>{errorMessage || error?.message}</p>
        )}
        {loading && (
          <p className={styles.loading}>
            <Loading />
          </p>
        )}
      </span>
    </div>
  );
};

export default FormField;
